import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

import { formatting } from "@/lib/formatting";

// Revenue / commission footer shared by the earnings rail cards.
export const EarningsCardAmounts = ({
  commissionDollars,
  commissionLabel = "Commission",
  revenueDollars,
}: {
  commissionDollars: number;
  commissionLabel?: string;
  revenueDollars: number;
}) => {
  /* Render */
  const render = () => (
    <Row className="mt-auto items-start gap-10 border-t border-slate-200 pt-3">
      <Column className="gap-0.5">
        <Text className="text-xs font-normal text-slate-500">Revenue</Text>
        <Text className="text-base font-semibold tabular-nums text-slate-900">
          ~{formatting.currency(revenueDollars)}
        </Text>
      </Column>
      <Column className="gap-0.5">
        <Text className="text-xs font-normal text-slate-500">
          {commissionLabel}
        </Text>
        <Text className="text-base font-semibold tabular-nums text-green-700">
          ~{formatting.currency(commissionDollars)}
        </Text>
      </Column>
    </Row>
  );

  return render();
};
